/**
 * Blog registry — the source of truth for /blog and /blog/:slug.
 * To add a post: drop a .jsx body into ./posts and register it here.
 */
import HowPublishersMakeMoney from './posts/how-publishers-make-money-in-2026.jsx';
import LeadJourney from './posts/the-lead-journey-after-your-ad.jsx';
import AudienceExtensionExample from './posts/audience-extension-worked-example.jsx';

export const POSTS = [
  {
    slug: 'how-publishers-make-money-in-2026',
    title: 'How publishers make money in 2026',
    excerpt:
      'Seven revenue lines reshaping B2B media and how the winners are recombining them into durable, high-margin portfolios.',
    cover:
      'https://images.unsplash.com/photo-1504711434969-e33886168f5c?auto=format&fit=crop&w=1600&q=80',
    category: 'Strategy',
    date: '2026-08-14',
    author: { name: 'The 5DBS Team', title: 'Publisher Insights' },
    Body: HowPublishersMakeMoney,
    // Rough word count used for reading time (kept static so we don't
    // walk the JSX tree at render time).
    words: 1250,
  },
  {
    slug: 'the-lead-journey-after-your-ad',
    title: 'The lead journey after your ad',
    excerpt:
      'What actually happens between a click on your ad and a signed contract — and where publisher margin lives inside it.',
    cover:
      'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1600&q=80',
    category: 'Product',
    date: '2026-08-06',
    author: { name: 'The 5DBS Team', title: 'Publisher Insights' },
    Body: LeadJourney,
    words: 900,
  },
  {
    slug: 'audience-extension-worked-example',
    title: 'Audience extension for B2B media: a worked example',
    excerpt:
      'A realistic 90-day campaign with numbers you can pressure-test — from placement to booked meetings to booked revenue.',
    cover:
      'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1600&q=80',
    category: 'Case studies',
    date: '2026-07-24',
    author: { name: 'The 5DBS Team', title: 'Publisher Insights' },
    Body: AudienceExtensionExample,
    words: 1100,
  },
];

export const getPostBySlug = (slug) => POSTS.find((p) => p.slug === slug);
